import {
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  Page,
  PageRoute,
  ScreenType,
  useParams,
  useValidationErrors,
} from "@compass/core";
import {
  ApplicationResponseFile,
  Permission,
  StudentApplicationEditResource,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { studentPageRoute } from "pages/students/students/StudentPage/StudentPage";
import { createEntity } from "utils";
import { FileDetailHeader } from "./FileDetailHeader";
import { FileDetailBody } from "./FileDetailBody";

const routeName = "fileDetail";

class Params {
  fileType: string = "applicationResponse";
  screenType: ScreenType = "dialog";
  crudMode: CrudMode = "edit";
  parentEntityId: number = 0; //  ApplicationResponse (parent) => ApplicationResponseFile (child)
  entityId: number = 0;
}

export const fileDetailPageRoute: PageRoute<Params> = {
  handle: "Upload File",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

const ROOT_PERMISSION: Permission = Permission.StudentServiceTemplate;

export const FileDetailPage = () => {
  const { params } = useParams(routeName, Params);

  const navigate = useNavigate();
  const [applicationFileResource, setApplicationFileResource] = useState<StudentApplicationEditResource>();
  const [applicationResponseFile, setApplicationResponseFile] = useState<ApplicationResponseFile>();
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    if (params.entityId != 0) {
      if (params.fileType == "applicationResponse") {
        ApiService.studentApplications.getApplicationResponseFile(params.entityId)
        .then((response) => {
          setApplicationResponseFile(response);
        });

        ApiService.studentApplications.getFileEditResource()
        .then((response) => {
          setApplicationFileResource(response);
        });
      }
    }
    else {
      if (params.fileType == "applicationResponse") {
        let newFile: ApplicationResponseFile = createEntity<ApplicationResponseFile>({
          applicationResponseId: params.parentEntityId
        });
        setApplicationResponseFile(newFile);

        ApiService.studentApplications.getFileEditResource()
        .then((response) => {
          setApplicationFileResource(response);
        });
      }
    }
    
  }, []);

  const pageHeader = (
    <FileDetailHeader
      crudMode={params.crudMode}
      applicationResponseFile={applicationResponseFile}
      entityId={params.entityId}
      fileType={params.fileType}
      onSave={(id) => {
        navigate(`../${studentPageRoute.getPath({ id: id, crudMode: "view" })}`);
      }}
    />
  );

  const pageBody = (
    <FileDetailBody
      crudMode={params.crudMode}
      applicationFileResource={applicationFileResource}
      applicationResponseFile={applicationResponseFile}
      setEditingApplicationResponseFile={setApplicationResponseFile}
    />
  );

  return params.screenType === "standard" ? (
    <>
      <Page isForm header={pageHeader}>
          {pageBody}
        </Page>
    </>
  ) : (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate)}
      maxWidth="lg"
      header={pageHeader}
      content={pageBody}
    />
  );
};
